import { db } from './firebase';
import { FIRESTORE_KEYS } from '../utils/constants';

export default function useSchoolAdminService() {
  const getSchoolAdmin = (id) =>
    db
      .collection(FIRESTORE_KEYS.SCHOOL_ADMINS)
      .doc(id)
      .get()
      .then((res) => res.data());

  const getTeacher = (id) =>
    db
      .collection(FIRESTORE_KEYS.TEACHERS)
      .doc(id)
      .get()
      .then((res) => res.data());

  const getParent = (id) =>
    db
      .collection(FIRESTORE_KEYS.PARENTS)
      .doc(id)
      .get()
      .then((res) => res.data());

  return { getSchoolAdmin, getParent, getTeacher };
}
